var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 52",
    d: "M0 0h30v5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 53",
    d: "M0 9h30v5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 54",
    d: "M0 18h30v5H0z"
  }))));
}
export default SvgMenu;